var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-fill"},[_c('DocumentNotificationSearch')],1),_c('div',{staticClass:"float-end"},[_c('DocumentPagination')],1)])]),_c('div',{staticClass:"card-body"},[_c('DocumentNotificationTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }